import { convertDollarsToCents } from '@clearverify/utils';

import { CompanyType, RevenueShareType } from 'src/api';

export const PrepareRevenueShareDataActionTypes = {
  Create: 'create',
  Update: 'update',
} as const;
export type PrepareRevenueShareDataActionTypes =
  (typeof PrepareRevenueShareDataActionTypes)[keyof typeof PrepareRevenueShareDataActionTypes];

export type RevenueShareFormSubmitDataType<T extends string = PrepareRevenueShareDataActionTypes> =
  {
    revenueShareSetting: Partial<
      Record<
        T,
        {
          revenueShareType: RevenueShareType;
          revenueShareFlat: number;
          revenueSharePercents: number;
        }
      >
    >;
  };

export const prepareRevenueShareData = (
  action: PrepareRevenueShareDataActionTypes,
  recipient: CompanyType,
  formValues: {
    revenueShareType: RevenueShareType;
    revenueShareValue: number;
    revenueShareReportEnabled: boolean;
  },
): RevenueShareFormSubmitDataType => {
  const { revenueShareType, revenueShareValue, revenueShareReportEnabled } = formValues;

  const actionValue = {
    revenueShareType,
    revenueShareFlat: 0,
    revenueSharePercents: 0,
    revenueShareRecipient: recipient,
  };

  const dataToSubmit = {
    revenueShareReportEnabled,
    revenueShareSetting: {
      [action]: actionValue,
    },
  };

  if (revenueShareType === RevenueShareType.Flat) {
    actionValue.revenueShareFlat = convertDollarsToCents(revenueShareValue);
    return dataToSubmit;
  }

  actionValue.revenueSharePercents = revenueShareValue;

  return dataToSubmit;
};

/** Same rule as the worker's buildRevenueShareRecipients: standalone, or flagged to keep its own share. */
export const employerReceivesOwnRevenueShare = (employer: {
  controlledBy: CompanyType;
  keepOwnRevenueShare: boolean;
}) => employer.controlledBy === CompanyType.Employer || employer.keepOwnRevenueShare;

export const peoReceivesOwnRevenueShare = (peo: {
  peoPayrollProvider?: { id: string } | null;
  keepOwnRevenueShare: boolean;
}) => !peo.peoPayrollProvider || peo.keepOwnRevenueShare;
